<h2 mat-dialog-title>{{ isEditMode ? 'Edit Member' : 'Add Member' }}</h2>
<div mat-dialog-content>
  <form [formGroup]="addMemberForm" #formDirective="ngForm" (ngSubmit)="onSubmit(formDirective)">
    <div class="row gx-4 my-1">
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>First Name</mat-label>
        <input
          matInput
          formControlName="first_name"
          placeholder="Enter First Name"
        />
        <mat-error
          *ngIf="
            addMemberForm.controls['first_name'].hasError('required') &&
            addMemberForm.controls['first_name'].touched
          "
        >
          First Name is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Last Name</mat-label>
        <input
          matInput
          formControlName="last_name"
          placeholder="Enter Last Name"
        />
        <mat-error
          *ngIf="
            addMemberForm.controls['last_name'].hasError('required') &&
            addMemberForm.controls['last_name'].touched
          "
        >
          Last Name is required
        </mat-error>
      </mat-form-field>

      <!-- Project -->
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Project</mat-label>
        <app-searchable-dropdown
          formControlName="account_id"
          [options]="projectOptions | searchableOptions:'account_name':'account_id'"
          placeholder="Select Project"
          class="w-100"
          (selectionChange)="onProjectChange({ value: $event })"
        ></app-searchable-dropdown>
        <mat-error
          *ngIf="
            addMemberForm.get('account_id')?.hasError('required') &&
            addMemberForm.get('account_id')?.touched
          "
        >
          Project is required
        </mat-error>
      </mat-form-field>

      <!-- Wing -->
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Wing</mat-label>
        <app-searchable-dropdown
          formControlName="block_id"
          [options]="wingOptions | searchableOptions:'block_name':'block_id'"
          placeholder="Select Wing"
          class="w-100"
          [disabled]="!selectedProject"
          (selectionChange)="onWingChange({ value: $event })"
        ></app-searchable-dropdown>
        <mat-error
          *ngIf="
            addMemberForm.get('block_id')?.hasError('required') &&
            addMemberForm.get('block_id')?.touched
          "
        >
          Wing is required
        </mat-error>
      </mat-form-field>

      <!-- Floor -->
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Floor</mat-label>
        <app-searchable-dropdown
          formControlName="floor_id"
          [options]="floorOptions | searchableOptions:'floor_name':'floor_id'"
          placeholder="Select Floor"
          class="w-100"
          [disabled]="!selectedWing"
          (selectionChange)="onFloorChange({ value: $event })"
        ></app-searchable-dropdown>
        <mat-error
          *ngIf="
            addMemberForm.get('floor_id')?.hasError('required') &&
            addMemberForm.get('floor_id')?.touched
          "
        >
          Floor is required
        </mat-error>
      </mat-form-field>

      <!-- Unit -->
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Unit</mat-label>
        <app-searchable-dropdown
          formControlName="floor_unit_id"
          [options]="unitOptions | searchableOptions:'floor_unit':'floor_unit_id'"
          placeholder="Select Unit"
          class="w-100"
          [disabled]="!selectedFloor"
          (selectionChange)="onFloorUnitChange({ value: $event })"
        ></app-searchable-dropdown>
        <mat-error
          *ngIf="
            addMemberForm.get('floor_unit_id')?.hasError('required') &&
            addMemberForm.get('floor_unit_id')?.touched
          "
        >
          Unit is required
        </mat-error>
      </mat-form-field>

      <!-- Role -->
      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Role</mat-label>
        <app-searchable-dropdown
          formControlName="role_id"
          [options]="roleOptions | searchableOptions:'role':'role_id'"
          placeholder="Select Role"
          class="w-100"
        ></app-searchable-dropdown>
        <mat-error
          *ngIf="
            addMemberForm.get('role_id')?.hasError('required') &&
            addMemberForm.get('role_id')?.touched
          "
        >
          Role is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>City</mat-label>
        <input matInput formControlName="city" placeholder="Enter City" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>State</mat-label>
        <input matInput formControlName="state" placeholder="Enter State" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Username</mat-label>
        <input
          matInput
          formControlName="username"
          placeholder="Enter Username"
        />
        <mat-error
          *ngIf="
            addMemberForm.controls['username'].hasError('required') &&
            addMemberForm.controls['username'].touched
          "
        >
          Username is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Email</mat-label>
        <input
          matInput
          type="email"
          formControlName="email_id"
          placeholder="Enter Email"
        />
        <mat-error
          *ngIf="
            addMemberForm.controls['email_id'].hasError('required') &&
            addMemberForm.controls['email_id'].touched
          "
        >
          Email is required
        </mat-error>
        <mat-error
          *ngIf="
            addMemberForm.controls['email_id'].hasError('email') &&
            !addMemberForm.controls['email_id'].hasError('required')
          "
        >
          Invalid email address
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-md-6">
        <mat-label>Mobile</mat-label>
        <input
          matInput
          formControlName="mob_no"
          placeholder="Enter Mobile No"
          type="number"
        />
        <mat-error
          *ngIf="
            addMemberForm.controls['mob_no'].hasError('required') &&
            addMemberForm.controls['mob_no'].touched
          "
        >
          Mobile number is required
        </mat-error>
        <mat-error
    *ngIf="
      addMemberForm.controls['mob_no'].hasError('pattern') &&
      !addMemberForm.controls['mob_no'].hasError('required')
    "
  >
    Invalid mobile number
  </mat-error>
      </mat-form-field>

      <!-- Profile Picture and Type in one row -->
      <div class="col-md-6">
        <label class="mb-2 d-block fw-semibold">Profile Picture</label>
        <div class="profile-upload-container">
          <div class="profile-preview" *ngIf="profilePicPreview">
            <img [src]="profilePicPreview" alt="Profile Preview" class="preview-image" (error)="handleImageError($event)">
            <button type="button" mat-icon-button class="remove-btn" (click)="removeProfilePic()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="upload-area" *ngIf="!profilePicPreview">
            <input 
              type="file" 
              id="profilePic" 
              accept="image/*" 
              (change)="onProfilePicSelected($event)"
              style="display: none;"
            >
            <label for="profilePic" class="upload-label">
              <mat-icon>add_a_photo</mat-icon>
              <span>{{ isEditMode ? 'Change Profile Picture' : 'Upload Profile Picture' }}</span>
            </label>
          </div>
        </div>
      </div>

      <!-- Type -->
      <div class="col-md-6">
        <label class="mb-0 d-block fw-semibold">Type</label>
        <mat-radio-group formControlName="is_owner" class="d-flex flex-row gap-3">
          <mat-radio-button value="Owner">Owner</mat-radio-button>
          <mat-radio-button value="Renter">Renter</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="addMemberForm.get('type')?.hasError('required') && addMemberForm.get('is_owner')?.touched">
          Type is required
        </mat-error>
      </div>

    </div>

    <div mat-dialog-actions align="end">
      <button mat-button mat-dialog-close type="button">Cancel</button>
      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="addMemberForm.invalid">
         {{ isEditMode ? 'Update' : 'Save' }}
      </button>
    </div>
  </form>
</div>
